<template>
  <div class="app-change-auto-top-up-wrapper">
    <slot name="txtBefore" v-if="!isSuccessView"></slot>
      <dyn-slot :slot-data="slotData" v-if="!isSuccessView">
        <slot name="txtDefault"></slot>
      </dyn-slot>
    <b-overlay v-if="showDefaultView" class="btn-next-overlay" :show="loading" spinner-small>
      <b-button v-on:click="nextView" class="btn-next" type="button" variant="primary" :disabled="loading">
        <slot name="btnNext">Betrag festlegen</slot>
      </b-button>
    </b-overlay>
    <activate-auto-top-up-wrapper
      v-if="showActivateTopUp"
      :monthly-value="monthlyValue"
      :auto-top-up="autoTopUp"
      :payment="autoTopUp.paymentType"
      :payment-type="true"
      @refresh="refreshQuery()"
    >
      <template v-for="slot in possibleChildSlotsFor('ChangeAutoTopUp')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </activate-auto-top-up-wrapper>
    <deactivate-auto-top-up-wrapper
      v-if="showDeactivateTopUp"
      :auto-top-up="autoTopUp"
      @refresh="refreshQuery()"
      :show-logout="showLogout"
    >
      <template v-for="slot in possibleChildSlotsFor('ChangeAutoTopUp')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </deactivate-auto-top-up-wrapper>
    <div class="noSavedPayment" v-if="showNoPayment">
      <slot name="txtNoPayment"></slot>
    </div>
  </div>
</template>
<script>
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import price from '@/mixins/price'
import { mapGetters, mapMutations } from 'vuex'
import ActivateAutoTopUpWrapper from '@/components/process/generic/TopUp/ChangeAutoTopUp/bild/ActivateAutoTopUpWrapper.vue'
import DeactivateAutoTopUpWrapper from '@/components/process/generic/TopUp/ChangeAutoTopUp/bild/DeactivateAutoTopUpWrapper.vue'

export default {
  name: 'ChangeAutoTopUpWrapper',
  props: {
    showLogout: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      monthlyValue: [2],
      autoTopUp: {
        activationPossible: false,
        active: false,
        paymentType: {},
        topUp: {
          amount: 0,
          trigger: 0,
          type: null
        }
      },
      loading: false,
      currentCustomer: {
        balance: null
      }
    }
  },
  components: { ActivateAutoTopUpWrapper, DeactivateAutoTopUpWrapper },
  computed: {
    formattedBalance () {
      if (this.currentCustomer.balance === null) {
        return '-'
      }
      return this.price(this.currentCustomer.balance)
    },
    formattedAmount () {
      return this.price(this.autoTopUp?.topUp?.amount)
    },
    formattedTrigger () {
      return this.price(this.autoTopUp?.topUp?.trigger)
    },
    slotData () {
      return {
        currentCustomer: this.currentCustomer,
        formattedBalance: this.formattedBalance,
        formattedAmount: this.formattedAmount,
        formattedTrigger: this.formattedTrigger
      }
    },
    ...mapGetters('topUp', [
      'currentView',
      'isSuccess'
    ]),
    showDefaultView () {
      return this.currentView === 'default'
    },
    showActivateTopUp () {
      return this.currentView === 'activate'
    },
    showDeactivateTopUp () {
      return this.currentView === 'deactivate'
    },
    showNoPayment () {
      return this.currentView === 'noPayment'
    },
    noPayment () {
      return this.autoTopUp.activationPossible === false
    },
    canDeactivate () {
      return this.autoTopUp.active
    },
    canActivate () {
      return this.canDeactivate === false
    },
    isSuccessView () {
      return this.isSuccess
    }
  },
  methods: {
    nextView: function () {
      if (this.canActivate) {
        this.setCurrentView('activate')
      } if (this.canDeactivate) {
        this.setCurrentView('deactivate')
      } if (this.noPayment && this.canActivate) {
        this.setCurrentView('noPayment')
      }
    },
    refreshQuery () {
      this.$apollo.queries.autoTopUp.refresh()
    },
    ...mapMutations('topUp', [
      'setCurrentView',
      'resetSuccess'
    ])
  },
  created () {
    this.setCurrentView('default')
    this.resetSuccess(false)
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query changeAutoTopUp {
        currentCustomer {
          balance
        }
      }`, this, 'currentCustomer')
    },
    autoTopUp: function () {
      return wrapQuery(gql`query changeAutoTopUp {
        autoTopUp{
          activationPossible,
          active,
           topUp {
             amount,
             trigger,
             type
            }
          paymentType {
            ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
           }
        }
      }`, this, 'autoTopUp')
    }
  },
  mixins: [
    transaction('changeAutoTopUp'),
    slotProxy(),
    price
  ]
}
</script>
